import Core from "../core";
import { AxiosError, AxiosResponse } from "axios";
const version = 'v2';

async function getDoToTaskList(company_id: number, user_id: number) {
  const api = Core.getInstance().api();
  try {
     const data = await api.get(
      `/${version}/get-to-do-tasks?company_id=${company_id}&user_id=${user_id}&locale=${localStorage.getItem(
        "emplang"
      )}`
    );

    if (data instanceof AxiosError) {
      return data.response;
    }
    const response = data.data;
    return response;
  } catch (error: any) {
    console.error(error)
  }
 
}
async function updateDoToTask(payload: object) {
  const api = Core.getInstance().api();
  try {
    const data = await api.put(`/${version}/update-to-do-tasks`,payload);

    if (data instanceof AxiosError) {
      return data.response;
    }
    const response = data.data;
    return response;
  } catch (error: any) {
    console.error(error)
  }
}

export const toDoTaskService = {
  getDoToTaskList,
  updateDoToTask
};
